import dayjs from "dayjs";

const TX_DAY_RE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * @param {string|undefined} value YYYY-MM-DD
 * @returns {string|null}
 */
export function parseAdminInvoiceTxDay(value) {
  if (value == null || value === "") return null;
  const day = String(value).trim();
  return TX_DAY_RE.test(day) ? day : null;
}

/**
 * Гүйлгээний хяналт — «Гүйлгээний огноо» RangePicker (createdAt).
 * @param {string} txFrom
 * @param {string} [txTo]
 * @returns {string}
 */
export function adminInvoiceTxSearchPath(txFrom, txTo) {
  const from = parseAdminInvoiceTxDay(txFrom);
  if (!from) return "/adminInvoice";
  const to = parseAdminInvoiceTxDay(txTo) || from;
  const q = new URLSearchParams({ txFrom: from, txTo: to });
  return `/adminInvoice?${q.toString()}`;
}

/**
 * Reconciliation settle өдрөөс invoice хайлтын өдөр.
 * @param {string} settleDate YYYY-MM-DD
 * @param {{ isPosAccount?: boolean, prevSettleDay?: string|null }} opts
 * @returns {string|null}
 */
export function invoiceTxDayFromSettleDate(settleDate, opts = {}) {
  const settle = parseAdminInvoiceTxDay(settleDate);
  if (!settle) return null;
  if (opts.isPosAccount) {
    const prev = parseAdminInvoiceTxDay(opts.prevSettleDay);
    if (prev) return prev;
    return dayjs(settle).subtract(1, "day").format("YYYY-MM-DD");
  }
  return settle;
}

/**
 * @param {[import("dayjs").Dayjs, import("dayjs").Dayjs]} range
 * @returns {{ txFrom: string, txTo: string }|null}
 */
export function adminInvoiceTxRangeFromQuery(txFrom, txTo) {
  const from = parseAdminInvoiceTxDay(txFrom);
  if (!from) return null;
  const to = parseAdminInvoiceTxDay(txTo) || from;
  return {
    txFrom: from,
    txTo: to,
    dayjsRange: [dayjs(from).startOf("day"), dayjs(to).endOf("day")],
  };
}
